import type { Node } from '@xyflow/react';

const COLS_OFFSET = 600;
const ROWS = 4;
const STEP_X = 410;
const STEP_Y = 410;

/**
 * 计算新建上游节点的落点：在目标节点左侧按网格排布
 * （先纵向填满一列，再向左扩展下一列），避免多次添加时重叠。
 *
 * 槽位索引按已连接的 upload 节点数量计算，图片/视频上传节点共享同一网格。
 */
export function computeUpstreamGridPosition(
  currentNode: Node,
  incomers: Node[],
): { x: number; y: number } {
  const index = incomers.reduce(
    (count, n) => (n.type === 'upload' ? count + 1 : count),
    0,
  );
  const row = index % ROWS;
  const col = Math.floor(index / ROWS);
  return {
    x: currentNode.position.x - COLS_OFFSET - col * STEP_X,
    y: currentNode.position.y + row * STEP_Y,
  };
}
